import { InjectionToken } from '@angular/core';

/**
 * Configuration interface for the AuthInterceptor
 * Each application provides its own config via this token
 */
export interface AuthInterceptorConfig {
  /** Application name for error logging (e.g., 'web-agencyportal', 'web-consumer') */
  appName: string;
  
  /** OAuth client ID for Basic Authentication */
  authUsername: string;
  
  /** OAuth client secret for Basic Authentication */
  authPassword: string;
  
  /** URL pattern to identify login requests (default: 'way-auth/auth/login') */
  loginUrlPattern?: string;
  
  /** Path patterns that should reload on 401 instead of redirecting to login */
  insurancePathPatterns?: string[];
  
  /** URL endpoint for error logging (e.g., 'https://api.example.com/error/public/log') */
  errorLogUrl?: string;

  /** URL patterns for requests that must not receive any Authorization header (e.g. S3 public GET). If any pattern is contained in the request URL, the request is passed through unchanged. */
  skipAuthUrlPatterns?: string[];
}

/**
 * Injection token for AuthInterceptor configuration
 * 
 * @example
 * ```typescript
 * providers: [
 *   {
 *     provide: AUTH_INTERCEPTOR_CONFIG,
 *     useValue: {
 *       appName: 'web-agencyportal',
 *       authUsername: environment.authUsername,
 *       authPassword: environment.authPassword
 *     }
 *   }
 * ]
 * ```
 */
export const AUTH_INTERCEPTOR_CONFIG = new InjectionToken<AuthInterceptorConfig>('AUTH_INTERCEPTOR_CONFIG');

